const baseUrl = '/api/customer/product'

export default {
    get: (params) => {
        return axios.get(`${baseUrl}?${params.join('&')}`)
    },
    store: (formData) => {
        return axios.post(baseUrl, formData)
    },
    save: (id, formData) => {
        return axios.post(`${baseUrl}/${id}`, formData)
    },
    delete: (id) => {
        return axios.delete(`${baseUrl}/${id}`)
    }
}
